import api from '@/utils/api';
import {Commit} from 'vuex'

const actions = {
  async api_mobile_protect_app_list_all(_context: { commit: Commit }, params: any) {
    return api.post('/api/mobile_protect/common_api/application_list_all', params)
  },
  async api_mobile_protect_common_query_judge_user_permissions(_context: { commit: Commit }) {
    return api.post('/api/mobile_protect/common_query_log/judge_user_permissions')
  },
  async api_mobile_protect_common_query_query_user_apply(_context: { commit: Commit }) {
    return api.post('/api/mobile_protect/common_query_log/query_user_apply')
  },
  async api_mobile_protect_common_query_save_user_apply(_context: { commit: Commit }, params: any) {
    return api.post('/api/mobile_protect/common_query_log/save_user_apply', params)
  },
  async api_mobile_protect_common_query_select_log_list(_context: { commit: Commit }, params: any) {
    return api.post('/api/mobile_protect/common_query_log/select_log_list', params)
  },

};

export default {
  actions
};
